import { FilterObject } from "@/types/Shared/Search";

const SEARCH_ENGINE_KEYS: Record<string, string> = {
  Width: "largura",
  Series: "altura",
  Rim: "aro"
};

const EMPTY_FILTERS: FilterObject[] = [{ Key: "", Value: "" }];

export function toSearchEngineFilters(filters: FilterObject[]): FilterObject[] {
  const SearchEngineFilters =
    filters
      ?.filter((filter) => filter?.Value !== undefined && filter?.Value !== null)
      .map((filter) => ({
        ...filter,
        Key: SEARCH_ENGINE_KEYS[filter.Key] ?? filter.Key
      })) ?? [];

  return SearchEngineFilters.length > 0 ? SearchEngineFilters : EMPTY_FILTERS;
}
